module.exports = __webpack_public_path__ + "img/ic_hotel_delivery.9c410ce2.png";